<section class="whatsapp">
  <button
    *crmInitVar="unreadCount$ | async as unreadCount"
    mat-icon-button
    matBadgeColor="warn"
    matBadgeSize="small"
    (click)="isOpen = !isOpen"
    [matBadge]="unreadCount"
    [matBadgeHidden]="!unreadCount || unreadCount === 0"
    class="button"
  >
    <mat-icon svgIcon="whatsapp-blue" class="-header-icon"></mat-icon>
  </button>
  <div class="whatsapp-popover" *ngIf="isOpen">
    <ng-template [cdkPortalOutlet]="domPortal"></ng-template>
  </div>

  <div #domPortalContent [class.-hidden]="!isOpen">
    <vim-core-widget-loader
      widgetTag="comm-thread-list-widget"
      [inputs]="{ types: 'whatsapp', limit: 20, isOpen: this.isOpen }"
      reloadOnChanges="true"
    ></vim-core-widget-loader>
  </div>
</section>
